"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleUpdateDesignForPrintables;
const either_1 = require("../../../types/either");
const updatePrintableDesign_1 = __importDefault(require("../updatePrintableDesign"));
const updateProjectVersion_1 = __importDefault(require("../updateProjectVersion"));
const UpdateDesignForPrintables_1 = require("../../../actions/UpdateDesignForPrintables");
const Printable_1 = require("../../../models/printables/Printable");
function handleUpdateDesignForPrintables(project, action, dependencies) {
  return __awaiter(this, void 0, void 0, function* () {
    if (!(0, UpdateDesignForPrintables_1.isUpdateDesignForPrintables)(action)) {
      return (0, either_1.left)(new Error('Action does not match update printable design schema'));
    }
    if (action.printableGroupAndPrintableIds.length === 0) {
      return (0, either_1.left)(new Error('No printables to update'));
    }
    const {
      getTemplate,
      getART
    } = dependencies;
    const getTemplateResult = yield getTemplate(project.product.sku, project.product.options, 'live');
    if (getTemplateResult.isLeft()) {
      return (0, either_1.left)(new Error(`Error fetching template for designId: ${action.designId}, with sku: ${project.product.sku}, options: ${project.product.options}, received: ${getTemplateResult.value}`));
    }
    const artResult = yield getART(project.product.sku);
    if (artResult.isLeft()) {
      return (0, either_1.left)(artResult.value);
    }
    let updatedProject = (0, updateProjectVersion_1.default)(project, action);
    const updatedPrintables = [];
    const updatePrintableDesignErrors = [];
    action.printableGroupAndPrintableIds.forEach(_ref => {
      let {
        printableGroupId,
        printableId
      } = _ref;
      const updatePrintableDesignResult = (0, updatePrintableDesign_1.default)(updatedProject, {
        type: 'UPDATE_PRINTABLE_DESIGN',
        projectId: action.projectId,
        timestamp: action.timestamp,
        designId: action.designId,
        printableGroupId,
        printableId
      }, getTemplateResult.value, artResult.value);
      if (updatePrintableDesignResult.isLeft()) {
        console.warn(updatePrintableDesignResult.value);
        updatePrintableDesignErrors.push(updatePrintableDesignResult.value);
        return;
      }
      updatedProject = updatePrintableDesignResult.value.updatedProject;
      updatedPrintables.push(...updatePrintableDesignResult.value.updatedEntities.filter(item => (0, Printable_1.isPrintable)(item)));
    });
    if (updatePrintableDesignErrors.length === action.printableGroupAndPrintableIds.length) {
      return (0, either_1.left)(new Error(updatePrintableDesignErrors.map(error => error.message).join('\n')));
    }
    return (0, either_1.right)({
      updatedProject,
      updatedEntities: [...updatedPrintables, updatedProject]
    });
  });
}